export enum CustomerSubscriptionFrequency {
    DAILY = 1,
    WEEKLY = 2,
    BIWEEKLY = 3,
    MONTHLY = 4,
    BIMONTHLY = 5,
    QUARTERLY = 6,
    SEMIANNUAL = 7,
    ANNUAL = 8,
    ADHOC = 9,
}
